<template>
  <WsCreate
    titleKey="name"
    :label="label"
    :fields="fields"
    :id="$route.params.id"
    :modelName="modelName"
    :primary="_pageSetting.primary"
    :secondary="_pageSetting.secondary"
    :staticModelData="staticModelData"
    :customCreateAction="customCreateAction"
  >
  </WsCreate>
</template>

<script>
import model from "@/models/role_type";
import subModel from "@/models/role";
export default {
  data(){
    return {
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      staticModelData: (modelData, fields) => {
        subModel.scopeFields.forEach(scope => {
          if (fields[scope].items.length) {
            fields[scope].items.forEach(valueItem => {
              let result = true;
              if (valueItem.value) {
                valueItem.value.forEach(item => {
                  if (result) result = modelData.scopes.includes(item);
                });
                if (result) {
                  modelData[scope] = [
                    ...(modelData[scope] || []),
                    ...valueItem.value,
                  ];
                }
              }
            });
          }
        });
      },
      customCreateAction: (modelData) => {
        modelData.scopes = [];
        subModel.scopeFields.forEach(scope => {
          if (modelData[scope] !== null && modelData[scope] !== undefined) {
            modelData.scopes.push(...modelData[scope]);
          }
        });
      },
    }
  },
  computed: {
    _pageSetting() {
      return {
        primary: [
          {
            type: "infoCard",
            floors: [
              {
                title: "角色類型資訊",
                fields: ["locales", "sequence"],
              },
              {
                title: "權限列表",
                fields: subModel.scopeFields,
              },
            ],
          },
        ],
        secondary: [
          {
            type: "infoCard",
            floors: [
              {
                title: "前台是否需要設定限閱領域",
                fields: ["has_factory_system"],
              },
              {
                title: "前台是否需要設定限閱轄下單位",
                fields: ["has_factory_scope"],
              },
            ],
          },
        ],
      };
    }
  }
};
</script>